import { render, staticRenderFns } from "./SimpleVehicleViewProfitTable.vue?vue&type=template&id=635ea17c&"
import script from "./SimpleVehicleViewProfitTable.vue?vue&type=script&lang=js&"
export * from "./SimpleVehicleViewProfitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports